var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b()},_vm._l((_vm.investmentProposals),function(investmentProposal){return _c('investment-proposals-list-item',{key:investmentProposal.id,class:_vm.b('item'),attrs:{"investment-proposal":investmentProposal,"selected":investmentProposal.id === _vm.selectedId},on:{"click":args => _vm.$emit('click-investment-proposal', args)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }